<template>
  <a class="button upload-images" href="#!" @click.prevent="openModal">Update your Details</a>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {},
	data() {
		return {};
	},
	methods: {
		openModal() {
			eventBus.$emit('update-details');
		}
	}
};
</script>
